<template>
  <span v-if="level" class="carrer-level">{{ carrerLevelLabel }}</span>
</template>

<script>
export default {
  computed: {
    carrerLevelLabel() {
      return this.$t(`jobDetail.careerLevel${this.level}`)
    },
  },
  props: {
    level: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.carrer-level {
  @apply inline-block rounded leading-emp-type text-center text-grey-900 border-grey-400 border;
  @apply text-base;
  @apply mb-4 px-2;
  font-weight: 300;
}
</style>
